import { render } from "./addAgent.vue?vue&type=template&id=9a1fcb16&scoped=true"
import script from "./addAgent.vue?vue&type=script&lang=js"
export * from "./addAgent.vue?vue&type=script&lang=js"

import "./addAgent.vue?vue&type=style&index=0&id=9a1fcb16&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1fcb16"]])

export default __exports__